<script>
  import Message from '@components/general/message.svelte'
  let { form, errorKeys = "*" } = $props()

  let errors = $derived.by(() => {
    if (!errorKeys || errorKeys === "*") return $form?.errors
    return Object.fromEntries(Object.entries($form?.errors || {}).filter(([key]) => errorKeys.includes(key)))
  })

  let message = $derived.by(() => {
    // If it's an empty string or empty array or empty object or null or undefined return null
    if (!errors) return null
    // If it's a string, return it directly
    if (typeof errors === 'string') return errors
    // If it's an array, join them with a comma
    if (Array.isArray(errors)) return errors.join(", ")
    // If it's an object, map it to key: value pairs and join with a comma
    return Object.entries(errors).map(([key, value]) => `${key}: ${value}`).join(", ")
  })

  function scrollIntoView(node) {
    node.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
  }

</script>

{#if message}
  <div {@attach scrollIntoView}>
    <Message type="error" {message} />
  </div>
{/if}
